import { autoinject, bindable, bindingMode, customElement } from 'aurelia-framework';
import { Toastr } from 'Code/Extension/Toastr';
import { ObjectHelper } from 'Code/Helpers/ObjectHelper';
import { BaseCustomElement } from 'Common/BaseCustomElement';
import { DataService } from 'DataAccessLayer/Services/DataService';

declare var bootstrap;
@customElement('review-card')
@autoinject
export class ReviewCardCustomElement extends BaseCustomElement {

    @bindable({ defaultBindingMode: bindingMode.toView }) reviewData: any = null;
    @bindable({ defaultBindingMode: bindingMode.toView }) showLink: boolean = false;

    private myModal: any = null;

    private dataService: DataService = null;
    private reportReviewText: string = null;

    constructor(dataService: DataService) {
        super();
        this.dataService = dataService;
    }

    async bind() {

    }

    private ShowReportReviewModalOpen() {
        this.myModal = new bootstrap.Modal(document.getElementById(`ReportReviewModal${this.guid}`));
        this.myModal.show();
    }

    private ShowReportReviewModalClose() {
        this.myModal.hide();
        this.myModal = null;
    }

    private async SwitchUserReactions() {
        if (this.reviewData.UserReactionsId != null && this.reviewData.UserReactionsId == 1) {
            this.reviewData.UserReactionsId = null;
        }
        else {
            this.reviewData.UserReactionsId = 1;
        }
        this.dataService.SetUserReactions('TripReview', this.reviewData.Id, null, this.reviewData.UserReactionsId);
    }

    private async ShowReportReviewModalSend() {
        let newTask: any = null;
        let response: any = await this.dataService.GetById('Task', 0);
        if (ObjectHelper.ObjectIs(response) && ObjectHelper.ObjectIs(response.data)) {
            newTask = JSON.parse(JSON.stringify(response.data));
        }

        newTask.c_Review_FK = this.reviewData.Id;
        newTask.Type_FK = 1274 //	Reported Review
        newTask.Description = this.reportReviewText;

        let resposne = await this.dataService.Create('Task', newTask);
        switch (resposne['status']) {
            case 'OK': {
                Toastr.Success('Toastr.Done', 'Toastr.SavingFormWasSuccessful');
                this.ShowReportReviewModalClose();
                break;
            }
            default: {
                Toastr.Error('Toastr.Oooops', resposne['message'], false);
                break;
            }
        }

    }
}
